import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CalendarDays, BarChart3, FileText, Gavel, Home, Images, LogOut, Menu, Play, Radio, ShieldCheck, Trophy, UserPlus, Users, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function MobileTabBar() {
  const { user, logout } = useAuth();
  const [sheetOpen, setSheetOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/scorer")) return null;

  const goSection = (id) => {
    setSheetOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 450);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const goHome = () => {
    if (location.pathname !== "/") navigate("/");
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const close = () => setSheetOpen(false);
  const tab = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return <>
    <nav className="mobile-tabbar" data-testid="mobile-tabbar">
      <button className={`mobile-tab ${location.pathname === "/" ? "active" : ""}`} onClick={goHome} data-testid="mobile-tab-home"><Home size={20} /><span>Home</span></button>
      <button className="mobile-tab" onClick={() => goSection("schedule")} data-testid="mobile-tab-matches"><CalendarDays size={20} /><span>Matches</span></button>
      <button className="mobile-tab" onClick={() => goSection("teams")} data-testid="mobile-tab-teams"><Trophy size={20} /><span>Teams</span></button>
      <Link className={`mobile-tab ${tab("/gallery") ? "active" : ""}`} to="/gallery" data-testid="mobile-tab-gallery"><Images size={20} /><span>Gallery</span></Link>
      <button className={`mobile-tab ${sheetOpen ? "active" : ""}`} onClick={() => setSheetOpen(!sheetOpen)} data-testid="mobile-tab-more"><Menu size={20} /><span>More</span></button>
    </nav>

    {sheetOpen && <div className="mobile-sheet-overlay" onClick={close} data-testid="mobile-sheet-overlay" />}
    <div className={`mobile-sheet ${sheetOpen ? "open" : ""}`} data-testid="mobile-sheet">
      <div className="sheet-head"><h4>MORE FROM KPL</h4><button className="sheet-close" onClick={close} data-testid="mobile-sheet-close" aria-label="Close menu"><X size={18} /></button></div>
      <Link className="sheet-link" to="/registrations" onClick={close} data-testid="sheet-registrations"><UserPlus size={17} /> Player Registration</Link>
      <Link className="sheet-link" to="/franchise-eoi" onClick={close} data-testid="sheet-eoi"><Gavel size={17} /> Franchise EOI — Bidding</Link>
      <button className="sheet-link" onClick={() => goSection("standings")} data-testid="sheet-points"><Trophy size={17} /> Points Table</button>
      <Link className="sheet-link" to="/live" onClick={close} data-testid="sheet-live"><Radio size={17} /> Live Scores & Commentary</Link>
      <Link className="sheet-link" to="/stats" onClick={close} data-testid="sheet-stats"><BarChart3 size={17} /> Season Stats</Link>
      <a className="sheet-link" href="https://www.fancode.com/" target="_blank" rel="noreferrer" onClick={close} data-testid="sheet-watch-live"><Play size={17} /> Watch Live on FanCode</a>
      <Link className="sheet-link" to="/auction-rules" onClick={close} data-testid="sheet-auction-rules"><FileText size={17} /> Auction Rules</Link>
      <Link className="sheet-link" to="/governing-council" onClick={close} data-testid="sheet-council"><Users size={17} /> Governing Council</Link>
      <Link className="sheet-link" to="/privacy-policy" onClick={close} data-testid="sheet-privacy"><ShieldCheck size={17} /> Privacy Policy</Link>
      <Link className="sheet-link" to="/terms-of-use" onClick={close} data-testid="sheet-terms"><FileText size={17} /> Terms Of Use</Link>
      {user ? <>
        {user.role === "admin" && <Link className="sheet-link" to="/admin" onClick={close} data-testid="sheet-dashboard"><Menu size={17} /> Admin Dashboard</Link>}
        <button className="sheet-link" onClick={async () => { close(); await logout(); navigate("/"); }} data-testid="sheet-logout"><LogOut size={17} /> Log out ({(user.name || "Fan").split(" ")[0]})</button>
      </> : <Link className="sheet-link sheet-login" to="/login" onClick={close} data-testid="sheet-login"><Users size={17} /> Log in / Create account</Link>}
    </div>
  </>;
}
